<div class="text-black font-semibold text-base sm:text-lg">
  {{ label }}
</div>

